import styled from "@emotion/styled";
import { DESKTOP, forDesktop } from "@/themes/device";
import { grayScale, sparta } from "@teamsparta/design-system";

export const Hero = styled.section`
  background-color: ${grayScale.gray100};
  padding: 50px 0 0;
  ${DESKTOP} {
    padding: 60px 0 0;
  }
`;

export const Hesitation = styled(Hero)`
  padding: 100px 0;
  ${DESKTOP} {
    padding: 120px 0;
  }
`;

export const Orientation = styled(Hesitation)``;
export const Competency = styled(Hesitation)``;
export const Worry = styled(Hesitation)``;
export const PreStudy = styled(Hesitation)`
  background-color: #f1f4ff;
`;

export const Breakthrough = styled(Hesitation)<{ course?: string }>`
background-color: ${({ course }) => (course === "mkt" ? "#f6f9fA" : "")};)}
`;
export const KnowHow = styled(Hesitation)``;
export const Mentor = styled(Hesitation)`
  background-color: #f6f9fa;
`;

export const Portfolio = styled(Hesitation)``;
export const StudentsWork = styled(Hesitation)``;
export const Reviews = styled(Hesitation)`
  background-color: ${grayScale.white};
`;

export const EndDateTimer = styled(Hesitation)`
  background-color: ${grayScale.white};
  padding: 90px 0;
  ${DESKTOP} {
    padding: 60px 0;
  }
`;
export const Qualification = styled(Hesitation)`
  background-color: ${grayScale.white};
  padding: 100px 0;
  ${DESKTOP} {
    padding: 120px 0;
  }
`;

export const Output = styled(Qualification)``;

export const OutputV2 = styled.section`
  background-color: ${grayScale.gray10};
  padding: 80px 0 0;
  ${DESKTOP} {
    padding: 100px 0;
  }
`;

export const SellingPoint = styled(Hesitation)<{ course?: string }>`
  background-color: ${({ course }) =>
    course === "mkt" ? grayScale.gray100 : grayScale.white};)}`;

export const Seniors = styled(Hesitation)<{ course?: string }>`
  background-color: ${({ course }) =>
    course === "mkt" ? grayScale.gray100 : "#f6f9fa"};)}`;

export const SeniorsV2 = styled.section`
  background-color: ${grayScale.gray100};
`;

export const QaSolution = styled(SellingPoint)`
  ${DESKTOP} {
    padding: 70px 0 120px;
  }
`;

export const CurriculumABT = styled.section`
  background-color: ${grayScale.gray100};
  padding: 80px 0;
  ${forDesktop} {
    padding: 100px 0;
  }
`;

export const Knowhow = styled(PreStudy)``;

export const Coaching = styled(SellingPoint)``;

export const Curriculum = styled(Hesitation)`
  background-color: #f6f9fa;
`;

export const Responsibility = styled(Hesitation)`
  background-color: white;
`;

export const Employment = styled.section`
  background-color: white;
`;

export const Partner = styled(SellingPoint)``;

export const SpartaKnowhow = styled(Hesitation)``;

export const Recruit = styled(SeniorsV2)``;

export const Price = styled(SellingPoint)``;

export const Life = styled(Hesitation)`
  background-color: ${grayScale.gray100};
`;
